// @flow
import React from 'react';
import styles from './switchLabel.css'

type SwitchLabelPropTypes = {
  fontSize?: string,
  text?: string,
}

const SwitchLabel = ({
  fontSize = 'medium',
  text = ''
}: SwitchLabelPropTypes) => (
  <div className={`
    ${styles.switchLabel}
    ${styles[fontSize]}
  `}>
    {text}
  </div>
)

export default SwitchLabel;


// WEBPACK FOOTER //
// ./src/scripts/components/SwitchLabel/index.jsx